export const CARD_ICONS: { [key: string]: string } = {
    'Visa': "fa fa-cc-visa",
    'Master': "fa fa-cc-mastercard"
  };